import FragmentWrapper from 'graphql-client/FragmentWrapper';

import {getDeclarativeTranslationsMapping} from '../DeclarativeTranslationsMapping';
import {GraphQLTypes} from './GraphQLTypes';

/**
 * Get a FragmentWrapper for the given declaration name
 *
 * @param declarationName e.g. "BioentitySummary"
 */
export function getFragmentWrapper<TDeclaration extends keyof GraphQLTypes>(
  declarationName: TDeclaration
): FragmentWrapper<GraphQLTypes[TDeclaration]> {
  const mapping = getDeclarativeTranslationsMapping();
  const ast = mapping.getDocumentWithDependenciesForFragment(declarationName);
  return {
    fragment: ast,
    fragmentName: `${declarationName}GraphQL`,
  };
}
